import React from 'react';
import styles from './Spinner.css'; // Create a CSS file for styling

export default function () {
    console.log('spinner wprking')
  return<div className='loading' ></div> 
};

// export default Spinner;
